<template>
  <ul class="level2">
    <li class="subhead" @click="select(item, index)" v-for="(item, index) in items" :key="index">
      {{item.name}}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'adx-menu-expansion-level2',
  props: {
    items: {
      required: false
    },
    lists: {
      required: false
    }
  },
  methods: {
    select(item, index) {
      this.$parent.select(item, index)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>